import React, { useMemo } from 'react'
import { useNavigation } from '@react-navigation/native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { AccountAvatarNavigationBar } from '@src/components/navigationBar/AccountAvatarNavigationBar'
import { Icon } from '@src/components/base'
import { useRefreshNotificationsOnFocus } from '@src/hooks/useRefreshNotificationsOnFocus'
import { InsightsContent } from '../components/InsightsContent'

export const InsightsScreen = () => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()

  useRefreshNotificationsOnFocus()

  const rightAccessories = useMemo(
    () => [
      {
        renderIconComponent: () => <Icon name="gear" style={styles.icon} />,
        onPress: () => navigation.navigate('InsightsSettings'),
        accessibilityLabel: 'Insights Settings',
      },
    ],
    [navigation, styles.icon],
  )

  return (
    <AccountAvatarNavigationBar title="Trends" rightAccessories={rightAccessories}>
      <InsightsContent />
    </AccountAvatarNavigationBar>
  )
}

const themedStyles = StyleService.create({
  icon: {
    marginRight: 16,
  },
})
